import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, Layout, PrimaryButton, SmartLink } from '@stashinvest/ui';
import {
	valuePropCtaClick,
	valuePropScreenView,
} from 'stash/actions/debitSignUpTrackingEvents';
import HeroSection from './HeroSection';
import StockbackFeedSection from './StockbackFeedSection';
import DisclosureSection from './DisclosureSection';
import { BanjoString } from '@stashinvest/react-banjo';
import { StatementsTile } from '../statementsTile';
import { AccountStatus } from '../../../bank/BankConstants';
import BANK_ACCOUNT_PARTNER_TYPE from 'stash/constants/partnerType';

const mapStateToProps = (state) => ({
	account: state?.entities?.bank?.debit_accounts,
});

const mapDispatchToProps = {
	valuePropScreenView,
	valuePropCtaClick,
};

export function ValuePropScreen({
	valuePropScreenView = () => {},
	valuePropCtaClick = () => {},
	account,
}) {
	const isClosedGreenDotUser =
		account &&
		account[0]?.partnerType === BANK_ACCOUNT_PARTNER_TYPE.GREENDOT &&
		account[0]?.status === AccountStatus.Closed;

	useEffect(() => {
		valuePropScreenView();
	}, [valuePropScreenView]);

	return (
		<Layout.PageWrap>
			<HeroSection />
			{isClosedGreenDotUser && <StatementsTile />}
			<Box width="100%" maxWidth="500px" mx="auto">
				<PrimaryButton as={SmartLink} to="/sign-up-debit" handleClick={valuePropCtaClick}>
					<BanjoString stringId={'action/startTask/getStockBackCard'} />
				</PrimaryButton>
			</Box>
			<StockbackFeedSection />

			<DisclosureSection />
		</Layout.PageWrap>
	);
}

ValuePropScreen.propTypes = {
	valuePropScreenView: PropTypes.func,
	valuePropCtaClick: PropTypes.func,
	account: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ValuePropScreen);
